import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DOCUMENTS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  parkDocId: string;
}

const mutateDeleteParkDoc = async ({ communityId, parkDocId }: mutateProps) => {
  return await axiosAuth.delete(`${DOCUMENTS_API(communityId)}/${parkDocId}`);
};

const useDeleteParkDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteParkDoc,
    ...queryParams,
  });

export default useDeleteParkDocMutation;
